import soundIcon from '~/assets/icons/sound_2.svg';
import soundOffIcon from '~/assets/icons/sound_off.svg';
import { rage, useObservable } from '~/rage';
import { ImgIcon } from '../ImgIcon';
import { StyledContainer } from './ToggleSound.styled';

interface IToggleSoundProps {
	className?: string;
}

const ToggleSound = ({
	className,
	...props
}: IToggleSoundProps & React.HTMLAttributes<HTMLDivElement>) => {
	const isMuted = useObservable(rage.sounds.getMutedObservable());

	return (
		<StyledContainer
			className={className}
			data-muted={isMuted || undefined}
			onClick={() => rage.sounds.toggleMuted()}
			{...props}
		>
			<ImgIcon
				icon={isMuted ? soundOffIcon : soundIcon}
				width={16}
				height={16}
			/>
		</StyledContainer>
	);
};

export { ToggleSound };
